import { PropertyManagementSystem } from "shared/types/partner";

// Is PMS is any other -> we treat partner as MANUAL
export const SupportedPropertyManagementSystem = [
  PropertyManagementSystem.Appfolio,
  PropertyManagementSystem.Buildium,
  PropertyManagementSystem.Entrata,
  PropertyManagementSystem.ManageAmerica,
  PropertyManagementSystem.Quext,
  PropertyManagementSystem.RentManager,
  PropertyManagementSystem.RentersWarehouse,
  PropertyManagementSystem.Rentvine,
  PropertyManagementSystem.Resman,
  PropertyManagementSystem.Yardi,
  PropertyManagementSystem.Propertyware,
  PropertyManagementSystem.Revela
];
